import {QuoteMode, QuoteAction, QuoteStatus} from '../../utils/Quote/Quote'

export function initialize() {
  this.state = {
    open: false,
    counter: 0,
    expirations: {},
    edit: {
      id: null,
      fields: {},
      errors: {},
      loading: false
    }
  }
}

export function changeMode(AdvisorQuoteId, mode) {
  this.setState({
    edit: {
      AdvisorQuoteId,
      mode,
      fields: {},
      errors: {},
      loading: false
    }
  })
}

export function toggle() {
  this.setState({open: !this.state.open})
}

export function updateStateProps(props) {
  this.setState(props)
}

export function changeField(name, value) {
  this.setState({
    edit: {
      ...this.state.edit,
      fields: {
        ...this.state.edit.fields,
        [name]: value
      },
      errors: {
        ...this.state.edit.errors,
        [name]: value
      }
    }
  })
}

export function setLoading(value) {
  this.setState({
    edit: {
      ...this.state.edit,
      loading: value
    }
  })
}

export function getUpdatedValues() {
  const {edit} = this.state

  if (edit.mode == QuoteMode.SET_PRICE) {
    return {
      quoteAction: QuoteAction.SET_PRICE,
      quote: {
        AdvisorQuoteId: edit.AdvisorQuoteId,
        AdvisorQuotePrice: parseFloat(edit.fields['AdvisorQuotePrice']),
        AdvisorQuoteDuration: parseFloat(edit.fields['AdvisorQuoteDuration'])
      }
    }
  } else if (edit.mode == QuoteMode.REJECT) {
    return {
      quoteAction: QuoteAction.REJECT,
      quote: {
        AdvisorQuoteId: edit.AdvisorQuoteId,
        AdvisorQuoteRejectReason: edit.fields['AdvisorQuoteRejectReason']
      }
    }
  } else {
    return {}
  }
}
